import request from '@/utils/request'

const certifyApi = {
  getUserCertificationInfo: '/certified/v1/getUserCertificationInfo',
  doPersonCertified: '/certified/v1/doPersonCertified',
  doEnterpriseCertified: '/certified/v1/doEnterpriseCertified',
  getPhoneVerifyCode: '/certified/v1/getPhoneVerifyCode',
}

export function getCertificationInfo(infoParam) {
  console.log('getCertificationInfo', infoParam)
  return request({
    url: certifyApi.getUserCertificationInfo,
    method: 'post',
    data: infoParam
  })
}

export function certifyPerson(personParam) {
  console.log('certifyPerson', personParam)
  return request({
    url: certifyApi.doPersonCertified,
    method: 'post',
    data: personParam
  })
}

export function certifyEnterprise(enterpriseParam) {
  console.log('certifyEnterprise', enterpriseParam)
  return request({
    url: certifyApi.doEnterpriseCertified,
    method: 'post',
    data: enterpriseParam
  })
}

export function certify(param) {
  console.log('certify', param)
  return request({
    url: certifyApi.doPersonCertified,
    method: 'post',
    data: param
  })
}

export function getPhoneVerifyCode(param) {
  console.log('certify', param)
  return request({
    url: certifyApi.getPhoneVerifyCode,
    method: 'post',
    data: param
  })
}
